export default { sha: '4448dca9e408f7d201ef173ba507347a24c92fe8', buildNumber: 'undefined' }
